import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

/**
 * Prekvapik__1 (Surprise 1) - Foldable surprise card (landscape)
 *
 * Layout: 1 landscape page, 4×3 grid with specific index mapping.
 * Fold and cut lines for paper folding.
 *
 * Migrated from C# EduFrame.Img10.Generators.Prekvapik__1
 */
export class Prekvapik__1 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage(true); // landscape
    const margin = PdfUnit.FromMillimeters(5);
    const size = { width: PdfSize.A4.height / 4, height: PdfSize.A4.width / 3 };

    const folds: number[][] = [
      [1, 2, 3],
      [0.5, 1, 2, 3, 3.5],
      [1, 2, 3],
    ];

    for (let y = 0; y < 3; y++) {
      for (let x = 0; x < 4; x++) {
        const rect = new PdfRect(
          margin + x * size.width,
          margin + y * size.height,
          size.width - 2 * margin,
          size.height - 2 * margin
        );

        let index: number;
        if (y === 0) {
          index = x;
        } else if (y === 1 && x === 1) {
          index = 4;
        } else if (y === 1 && x === 2) {
          index = 5;
        } else if (y === 2) {
          index = 6 + x;
        } else {
          index = -1;
        }

        if (index >= 0 && index < opts.list.length) {
          page.drawLabel(opts.list[index].left, { rect });
        }
      }
    }

    // Fold lines (vertical)
    for (let y = 0; y < folds.length; y++) {
      for (const d of folds[y]) {
        const p1 = new PdfPoint(d * size.width, y * size.height);
        const p2 = new PdfPoint(d * size.width, (y + 1) * size.height);
        page.drawLine(GUtil.foldPen, p1, p2);
      }
    }

    // Cut lines (horizontal)
    for (let y = 1; y <= 2; y++) {
      const p1 = new PdfPoint(0.5 * size.width, y * size.height);
      const p2 = new PdfPoint(3.5 * size.width, y * size.height);
      page.drawLine(GUtil.cutPen, p1, p2);
    }
  }
}
